import { LoadingState } from "@/utils/loadingUtils"

const LoadingMixin = {
  data() {
    return {
      state: LoadingState.loading,
      i18nErrorType: 'unknown'
    }
  },
  methods: {
    handleError(_err: any) {
      (this as any).state = LoadingState.error;
    },
    getI18nErrorString() {
      return 'common.error.' + (this as any).i18nErrorType
    },
    handleErrorWithI18nString(err: any) {
      if (err && err.response && err.response.data && typeof err.response.data.error === 'string') {
        if (Array.isArray(err.response.data.payload) && err.response.data.payload.length > 0) {
          (this as any).i18nErrorType = err.response.data.error + '_' + err.response.data.payload[0]
        } else {
          (this as any).i18nErrorType = err.response.data.error
        }
      }
      (this as any).state = LoadingState.error;
    },
    handleSuccess() {
      (this as any).state = LoadingState.success;
    }
  }
}

export default LoadingMixin
